import {
  Card,
  Avatar,
  Image,
  Text,
  Button,
  Divider,
  Modal,
  Space,
  Title,
  Container,
} from "@mantine/core";
import { useDisclosure, useMediaQuery } from "@mantine/hooks";
import classes from "./FeatureCard.module.css";
import I18n from "../../i18n.js";
import parse from "html-react-parser";

interface FeatureCardProps {
  featureName: string;
  featureText: string;
  longText: string;
  modalText: string;
  icon: React.ElementType;
  image: string;
}

export function FeatureCard({
  featureName,
  featureText,
  longText,
  modalText,
  icon: Icon,
  image,
}: FeatureCardProps) {
  const [opened, { open, close }] = useDisclosure(false);
  const isMobile = useMediaQuery("(max-width: 50em)");

  return (
    <>
      <Modal
        size="lg"
        opened={opened}
        onClose={close}
        title={<Title>{featureName}</Title>}
        fullScreen={isMobile}
      >
        <Space h="md" />
        {<Image radius="md" src={image} />}
        <Space h="md" />
        <Divider />
        <Space h="md" />
        <Text>{parse(modalText)}</Text>
        <Divider />
        <Button
          fullWidth
          className={classes.button}
          color={"#76c425"}
          variant="outline"
          onClick={() => {
            close();
          }}
        >
          {I18n.t("general.close")}
        </Button>
      </Modal>
      <Card
        w={"20%"}
        withBorder
        padding="xl"
        radius="md"
        className={classes.card}
      >
        <Card.Section h={140}>
          <Image src={image} height={140} alt={featureName} />
        </Card.Section>
        <Avatar
          size={90}
          radius={80}
          mx="auto"
          mt={-30}
          className={classes.avatar}
        >
          <Icon size="50" color={"#76c425"}/>
        </Avatar>
        <Card.Section h={240}>
          <Text component="h3" ta="center" fz="lg" fw={500} mt="sm">
            {featureName}
          </Text>
          <Text ta="center" fz="sm" c="dimmed">
            {featureText}
          </Text>
          <Divider my="sm" />
          <Container w={"90%"}>
            <Text ta="center" fz="sm" c="dimmed">
              {longText}
            </Text>
          </Container>
        </Card.Section>
        <Button
          fullWidth
          radius="md"
          mt="xl"
          size="md"
          variant="light"
          color={"#3a6410"}
          onClick={open}
        >
          {I18n.t("general.learnMore")}
        </Button>
      </Card>
    </>
  );
}
